import type {PropsWithChildren} from 'react'
import {useChromelessPostSizing} from '@freckle/classroom/ts/hooks/use-chromeless-post-message'
import {ChromelessContext} from './context'

type ChromelessProps = PropsWithChildren<{
  /**
   * Opt-in: post a Renaissance Next `sizing` message to the parent frame on every
   * layout change. Use on read-only report routes so the parent can grow the iframe
   * to fit the report and avoid nested scrollbars. Do NOT enable on flows that
   * render in a parent-owned modal (e.g. assignment creation) — the parent expects
   * to control the iframe dimensions there.
   */
  reportSizing?: boolean
}>

export const Chromeless = ({children, reportSizing = false}: ChromelessProps) => (
  // N.B. `value` implies `value=true`, omitting `=true` is required by eslint
  <ChromelessContext value>
    {reportSizing && <SizingReporter />}
    {children}
  </ChromelessContext>
)

const SizingReporter = () => {
  useChromelessPostSizing()
  return null
}
